import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../../store";
import {
  saveBankAccount,
  updateBankAccount,
} from "../../../../../../../../acions/customers/bankAccounts";
import { FormInstance } from "antd";
import { usePermissions } from "../../../../../../../../lib/hooks/usePermissions";

export const useFormHandlers = (
  form: FormInstance,
  customerId: string,
  selectedItem: any | null,
  reloadOnSaved: () => void,
  reload: () => void,
) => {
  const dispatch = useAppDispatch();

  const { hasAccess } = usePermissions();

  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);

  useEffect(() => {
    !hasAccess("CustomersBankAccounts", selectedItem ? "Modify" : "Add") &&
      setIsFormDisabled(true);
  }, [hasAccess, selectedItem]);

  const onAddClicked = useCallback(
    async (isNew: boolean) => {
      try {
        const res = await form.validateFields();
        const request = { ...res, customerId };

        setIsFormDisabled(true);

        await Promise.resolve(
          dispatch(
            !selectedItem
              ? saveBankAccount(request)
              : updateBankAccount(selectedItem.id, request),
          ),
        );
        form.resetFields();
        setIsFormDisabled(false);
        isNew ? reload() : reloadOnSaved();
      } catch {
        setIsFormDisabled(false);
      }
    },
    [form, dispatch, reloadOnSaved, reload, customerId, selectedItem],
  );

  return { onAddClicked, isFormDisabled, setIsFormDisabled };
};
